import { useGamesWithCategories } from './useGamesWithCategories'

export default function useGames() {
  return useGamesWithCategories({ select: ({ games }) => games })
}
